// extracted by mini-css-extract-plugin
export default {"cardContainer":"Beer_cardContainer__e5gf0"};